export const teamCards = [
  {
    name: 'cards',
    path: '/cards',
    component: () =>
      import(
        /* webpackChunkName: 'cards-index' */ '@/modules/cards/_views/Index'
      ),
    redirect: { name: 'physical_cards' },
    children: [
      {
        name: 'budget_cards',
        path: '/budget-cards',
        meta: {
          section: 'cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-budgets' */ '@/modules/cards/_views/BudgetCardsIndex'
          )
      },
      {
        name: 'physical_cards',
        path: '/physical-cards',
        meta: {
          section: 'cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-physical' */ '@/modules/cards/_views/PhysicalCardsIndex'
          )
      },
      {
        name: 'all_cards',
        path: '/all-cards',
        meta: {
          section: 'cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-physical' */ '@/modules/cards/_views/AllCardsIndex'
          )
      },
      {
        name: 'virtual_cards',
        path: '/virtual-cards',
        meta: {
          section: 'cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-virtual' */ '@/modules/cards/_views/VirtualCardsIndex'
          )
      }
    ]
  }
]

export const myCards = [
  {
    name: 'my_cards',
    path: '/my-cards',
    component: () =>
      import(
        /* webpackChunkName: 'cards-index' */ '@/modules/cards/_views/MyCardsIndex'
      ),
    redirect: { name: 'my_physical_cards' },
    children: [
      {
        name: 'my_virtual_cards',
        path: '/my-virtual-cards',
        meta: {
          section: 'my_cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-virtual' */ '@/modules/cards/_views/MyVirtualCardsIndex'
          )
      },
      {
        name: 'my_physical_cards',
        path: '/my-physical-cards',
        meta: {
          section: 'my_cards',
          allowedRoles: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN', 'ROLE_REGULAR']
        },
        component: () =>
          import(
            /* webpackChunkName: 'cards-physical' */ '@/modules/cards/_views/MyPhysicalCardsIndex'
          )
      }
    ]
  }
]
